/* Alkemia House — sticky add-to-bag, free-shipping progress, cart recommendations.
   Load AFTER theme.js. Reuses its helpers: window.vyFormatMoney, the
   `cart:updated` event (fired on every drawer render), the delegated
   [data-product-form] submit handler and [data-add-id] quick-add buttons. */
(function () {
  'use strict';

  function money(cents) {
    return window.vyFormatMoney ? window.vyFormatMoney(cents) : (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var root = document.documentElement;
  /* Store-currency amounts (free-shipping threshold) → the shopper's presentment currency */
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;

  /* ───────────────────── Sticky add-to-bag ───────────────────── */
  function initSticky(bar) {
    var formId = bar.dataset.formId;
    var form = document.getElementById(formId);
    if (!form) return;
    var anchor = form.querySelector('[data-sticky-anchor]') || form;
    var scope = form.closest('section') || document;
    var mainSelect = form.querySelector('select[name="id"]');
    var stickySelect = bar.querySelector('[data-sticky-variant]');
    var addBtn = bar.querySelector('[data-sticky-add]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var imgEl = bar.querySelector('[data-sticky-img]');
    var addText = bar.dataset.addText || 'Add to bag';
    var soldText = bar.dataset.soldText || 'Sold out';

    var variants = [];
    var dataEl = document.querySelector('script[data-variants-for="' + formId + '"]');
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    function find(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function hasCompare(v) { return v.compare_at_price && v.compare_at_price > v.price; }

    function apply(v, updateUrl) {
      if (!v) return;
      // Sticky price
      if (priceEl) priceEl.innerHTML = '<span>' + esc(money(v.price)) + '</span>' +
        (hasCompare(v) ? ' <s>' + esc(money(v.compare_at_price)) + '</s>' : '');
      // Main PDP price — Jalupro has a separate [data-compare-price], VYBES nests <s>
      var mainPrice = scope.querySelector('[data-price]');
      var cmp = scope.querySelector('[data-compare-price]');
      if (mainPrice) {
        if (cmp) {
          mainPrice.textContent = money(v.price);
          cmp.textContent = hasCompare(v) ? money(v.compare_at_price) : '';
          cmp.hidden = !hasCompare(v);
        } else {
          mainPrice.innerHTML = esc(money(v.price)) + (hasCompare(v) ? '<s>' + esc(money(v.compare_at_price)) + '</s>' : '');
        }
      }
      // Availability on both buttons
      var mainBtn = form.querySelector('button[type="submit"]');
      if (mainBtn) {
        mainBtn.disabled = !v.available;
        var ml = mainBtn.querySelector('[data-atc-label]');
        if (ml) ml.textContent = v.available ? addText : soldText;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        var sl = addBtn.querySelector('[data-sticky-label]');
        if (sl) sl.textContent = v.available ? addText : soldText;
      }
      // Variant image
      if (v.image) {
        var main = scope.querySelector('[data-gallery-main]');
        if (main) main.src = v.image;
        if (imgEl && v.thumb) imgEl.src = v.thumb;
      }
      if (stickySelect && stickySelect.value !== String(v.id)) stickySelect.value = String(v.id);
      if (updateUrl && history.replaceState) {
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }

    if (mainSelect) mainSelect.addEventListener('change', function () { apply(find(mainSelect.value), true); });
    if (stickySelect) stickySelect.addEventListener('change', function () {
      if (mainSelect) mainSelect.value = stickySelect.value;
      apply(find(stickySelect.value), true);
    });

    // The sticky button submits the real PDP form → theme.js handles the add, toast and drawer
    if (addBtn) addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    // Show once the main buy row has scrolled up out of view; hide when it's back
    var visible = false;
    function setVisible(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.inert = !on;
      root.classList.toggle('vy-sticky-on', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // not on screen AND above the viewport (scrolled past, not yet reached)
        setVisible(!e.isIntersecting && e.boundingClientRect.top < window.innerHeight / 2);
      }, { rootMargin: '-110px 0px 0px 0px', threshold: 0 }).observe(anchor);
    }
  }
  document.querySelectorAll('[data-sticky-atc]').forEach(initSticky);

  /* Keep the bar out of the way while the cart drawer is open */
  var drawer = document.getElementById('CartDrawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      root.classList.toggle('vy-cart-open', drawer.classList.contains('is-open'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ───────────────────── Free-shipping progress ───────────────────── */
  var fs = document.querySelector('[data-freeship]');
  var fsPrimed = false;
  function renderFreeShip(cart) {
    if (!fs) return;
    var threshold = Math.round((parseInt(fs.dataset.threshold, 10) || 0) * rate);
    if (!threshold || !cart || !cart.item_count) { fs.hidden = true; fs.classList.remove('is-eligible'); return; }
    var total = cart.total_price || 0;
    var remaining = Math.max(0, threshold - total);
    var eligible = remaining === 0;
    var tpl = eligible ? fs.dataset.eligibleText : fs.dataset.progressText;
    var msg = fs.querySelector('[data-freeship-msg]');
    var fill = fs.querySelector('[data-freeship-fill]');
    if (msg) msg.innerHTML = '<span class="vy-star" aria-hidden="true"></span><span>' +
      esc(tpl).replace('[amount]', '<strong>' + esc(money(remaining)) + '</strong>') + '</span>';
    if (fill) fill.style.width = Math.min(100, (total / threshold) * 100).toFixed(1) + '%';
    var was = fs.classList.contains('is-eligible');
    fs.classList.toggle('is-eligible', eligible);
    fs.hidden = false;
    if (eligible && !was && fsPrimed) {
      fs.classList.remove('is-celebrate');
      void fs.offsetWidth; // restart the animation
      fs.classList.add('is-celebrate');
    }
    fsPrimed = true;
  }

  /* ───────────────────── Cart recommendations ───────────────────── */
  var recs = document.querySelector('[data-cart-recs]');
  var recsList = recs && recs.querySelector('[data-cart-recs-list]');
  var recCache = {};
  var recSeq = 0;

  function fetchRecs(pid, intent) {
    var key = pid + '|' + intent;
    if (!recCache[key]) {
      var url = recs.dataset.url + '.json?product_id=' + encodeURIComponent(pid) +
        '&limit=10&intent=' + encodeURIComponent(intent);
      recCache[key] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }
    return recCache[key];
  }
  function fetchWithFallback(pid, intent) {
    return fetchRecs(pid, intent).then(function (list) {
      // "complementary" needs Search & Discovery pairings — fall back to "related" when empty
      return list.length || intent === 'related' ? list : fetchRecs(pid, 'related');
    });
  }
  function firstAvailable(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return null;
  }
  function sizedImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function recCard(p) {
    var v = firstAvailable(p);
    var addLabel = recs.dataset.addLabel || 'Add';
    var chooseLabel = recs.dataset.chooseLabel || 'Choose';
    var img = sizedImg(p.featured_image, 240);
    var price = esc(money(v.price));
    if (v.compare_at_price && v.compare_at_price > v.price) price += ' <s>' + esc(money(v.compare_at_price)) + '</s>';
    var action = (p.variants || []).length === 1
      ? '<button type="button" class="vy-rec__add" data-add-id="' + v.id + '" data-add-name="' + esc(p.title) +
        '" aria-label="' + esc(addLabel + ' ' + p.title) + '">+ ' + esc(addLabel) + '</button>'
      : '<a class="vy-rec__add" href="' + esc(p.url) + '">' + esc(chooseLabel) + '</a>';
    return '<div class="vy-rec">' +
      '<a class="vy-rec__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="120" height="120" loading="lazy">' : '') +
      '</a>' +
      '<a class="vy-rec__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="vy-rec__price">' + price + '</span>' +
      action +
      '</div>';
  }
  function hideRecs() { recs.hidden = true; recsList.innerHTML = ''; }

  function renderRecs(cart) {
    if (!recs || !recsList) return;
    var items = (cart && cart.items) || [];
    var inCart = {};
    var seeds = [];
    items.forEach(function (it) {
      inCart[it.product_id] = true;
      if (seeds.indexOf(it.product_id) < 0) seeds.push(it.product_id);
    });
    if (!seeds.length) { hideRecs(); return; }
    seeds = seeds.slice(0, 3); // most recently added first
    var limit = parseInt(recs.dataset.limit, 10) || 6;
    var intent = recs.dataset.intent || 'related';
    var seq = ++recSeq;
    Promise.all(seeds.map(function (id) { return fetchWithFallback(id, intent); })).then(function (groups) {
      if (seq !== recSeq) return; // a newer cart state is already rendering
      var seen = {}, out = [];
      var longest = groups.reduce(function (m, g) { return Math.max(m, g.length); }, 0);
      // Interleave so every product in the bag contributes suggestions
      for (var i = 0; i < longest && out.length < limit; i++) {
        groups.forEach(function (g) {
          var p = g[i];
          if (!p || out.length >= limit || inCart[p.id] || seen[p.id] || !firstAvailable(p)) return;
          seen[p.id] = true;
          out.push(p);
        });
      }
      if (!out.length) { hideRecs(); return; }
      recsList.innerHTML = out.map(recCard).join('');
      recsList.scrollLeft = 0;
      recs.hidden = false;
    });
  }

  // Quick-add feedback (theme.js does the actual add via [data-add-id])
  if (recs) recs.addEventListener('click', function (e) {
    var b = e.target.closest('.vy-rec__add[data-add-id]');
    if (b) b.classList.add('is-adding');
  });

  /* ───────────────────── Wiring ───────────────────── */
  function onCart(cart) { renderFreeShip(cart); renderRecs(cart); }
  document.addEventListener('cart:updated', function (e) { if (e.detail) onCart(e.detail); });

  // Initial state from the server-rendered drawer (no extra /cart.js request)
  if (drawer) {
    var ids = (drawer.dataset.cartProducts || '').split(',').filter(Boolean);
    onCart({
      item_count: parseInt(drawer.dataset.itemCount, 10) || 0,
      total_price: parseInt(drawer.dataset.cartTotal, 10) || 0,
      items: ids.map(function (id) { return { product_id: parseInt(id, 10) }; })
    });
  }
})();
